export default __webpack_public_path__ + "static/media/ChaletComprime-HongKongSixty.249874c6.woff2";